export default __webpack_public_path__ + "static/media/logo1.bd933fbc.png";